import React from 'react';
import { Box, Typography, Paper, Stack, Divider } from '@mui/material';
import EventRow from './EventRow';
import { groupEventsByDate, formatDateHeading } from './eventUtils';

const EventListView = ({ events }) => {
  if (!events || events.length === 0) {
    return (
      <Paper elevation={2} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          Geen events gepland.
        </Typography>
      </Paper>
    );
  }

  const groups = Array.from(groupEventsByDate(events).entries())
    .map(([key, dayEvents]) => ({
      date: new Date(key),
      events: [...dayEvents].sort((a, b) => new Date(a.start_time) - new Date(b.start_time)),
    }))
    .sort((a, b) => a.date - b.date);

  return (
    <Stack spacing={4}>
      {groups.map(({ date, events: dayEvents }) => (
        <Box key={date.toISOString()}>
          <Typography variant="h6" sx={{ mb: 1.5, textTransform: 'capitalize' }}>
            {formatDateHeading(date)}
          </Typography>
          <Paper elevation={2}>
            {dayEvents.map((event, idx) => (
              <React.Fragment key={event.id}>
                {idx > 0 && <Divider />}
                <EventRow event={event} />
              </React.Fragment>
            ))}
          </Paper>
        </Box>
      ))}
    </Stack>
  );
};

export default EventListView;
